import { createSelector } from 'reselect';
import { getFormValues, formValueSelector } from 'redux-form';
import { selectors as wlSelectors } from '@ux/whitelabel';
import * as r from 'ramda';

export const getConfig = r.path([ 'upm', 'config' ]);
export const getRibbon = r.path([ 'upm', 'ribbon' ]);

export const getCategories = createSelector(
  getConfig,
  r.prop('categories'),
);

export const getCookiesToPreserve = createSelector(
  getConfig,
  r.prop('cookiesToPreserve'),
);

export const getDomain = () => r.path([ 'utag', 'cfg', 'domain' ], window);

export const isRibbonDismissed = createSelector(
  getRibbon,
  r.prop('dismissed'),
);

const getInvalidateOptPre = createSelector(
  getConfig,
  r.prop('invalidateOptPre'),
);

const hasTealium = r.propSatisfies(r.complement(r.isNil), 'utag').bind(null, window);

const getPwInteraction = r.path([
  'utag',
  'data',
  'cp.pwinteraction',
]).bind(null, window);

export const getMergedFormValues = createSelector(
  getFormValues('inlinePrivacy'),
  getFormValues('privacyRibbon'),
  r.merge,
);

export const shouldShowConsent = r.converge(
  (hasTealium, pwinteraction, invalidBefore) => {
    if (!hasTealium) {
      return false;
    }

    if (pwinteraction == null) {
      return true;
    }

    if (pwinteraction === 'yes') {
      if (invalidBefore == null) {
        return false;
      }

      return true;
    }

    let parsedPw;
    if (r.is(String, pwinteraction)) {
      parsedPw = JSON.parse(pwinteraction);
    } else {
      parsedPw = pwinteraction;
    }

    const invalidBeforeDateTime = new Date(invalidBefore)
    const timestamp = new Date(parsedPw.timestamp);

    return timestamp.getTime() < invalidBeforeDateTime.getTime();
  },
  [ hasTealium, getPwInteraction, getInvalidateOptPre ],
);

export const shouldSendEvent = r.T;

export const getCategoryOrder = createSelector(
  wlSelectors.getBrandConfig,
  r.pathOr([], [ 'analytics', 'tealium', 'privacy', 'categories' ]),
);

const valueSelector = formValueSelector('privacyRibbon');
export const isExpanded = (state) => valueSelector(state, 'expanded');
